import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirGhostOwnershipService {

  constructor(private http: HttpClient) { }

  triggerOwnership(returnClobSettingsObj: any, baseUrl: string, globalService: any): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=epbs2g`;
    const filterParams = globalService?.filterParams || {};
    let params = { ...filterParams };
    params.sso_id = returnClobSettingsObj.sso_id;

    if (globalService?.globalParams) {
      params = { ...globalService.globalParams, ...params };
    }
    
    params.process_name = "TRIGGER_GHOST_OWNERSHIP";
    
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      formData.append(key, params[key]);
    });
    
    const options = {
      withCredentials: true
    };
    
    return this.http.post<any>(url, formData, options).pipe(
      catchError(error => {
        throw error;
      })
    );
  }
} 
